import { ChildrenProps } from "@hex-insights/core";
import { PermissionRequired } from "@hex-insights/permissioning";
import { permissions } from "../../../../Utilities";

export type CreatePermissionRequiredProps = Partial<ChildrenProps>;

const createPermissions = [
	permissions.StudentOTCMedication.Create.Admin,
	permissions.StudentOTCMedication.Create.Basic,
];

export function StudentOTCMedicationCreatePermissionRequired({ children }: CreatePermissionRequiredProps) {
	return (
		<PermissionRequired requiredPermissions={createPermissions} checkMethod="or">
			{children}
		</PermissionRequired>
	);
}

export type UpdatePermissionRequiredProps = Partial<ChildrenProps>;

const updatePermissions = [
	permissions.StudentOTCMedication.Update.Admin,
	permissions.StudentOTCMedication.Update.Basic,
];

export function StudentOTCMedicationUpdatePermissionRequired({ children }: UpdatePermissionRequiredProps) {
	return (
		<PermissionRequired requiredPermissions={updatePermissions} checkMethod="or">
			{children}
		</PermissionRequired>
	);
}

export type DeletePermissionRequiredProps = Partial<ChildrenProps>;

const deletePermissions = [
	permissions.StudentOTCMedication.Delete.Admin,
	permissions.StudentOTCMedication.Delete.Basic,
];

export function StudentOTCMedicationDeletePermissionRequired({ children }: DeletePermissionRequiredProps) {
	return (
		<PermissionRequired requiredPermissions={deletePermissions} checkMethod="or">
			{children}
		</PermissionRequired>
	);
}
